import CommentListQuery from "./commentListQuery";
import CommentList from "./CommentList";

export default CommentListQuery(CommentList);



// WEBPACK FOOTER //
// ./src/components/CommentList/index.jsx